import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { fetchOffers, fetchReferral } from "./actionCreator";

export const offerSlice = createSlice({
  name: "offers",
  initialState,
  reducers: {
    setPaginationModel(state, action) {
      console.log("offer action", action);
      state.page = action.payload.page;
      state.limit = action.payload.pageSize;
    },
    resetPaginationModel(state, action) {
      state.page = 0;
      state.limit = 25;
    },
    resetReferralPaginationModel(state, action) {
      state.referralPage = 0;
      state.referralLimit = 25;
    },

    setReferralPaginationModel(state,action){
      state.referralPage = action.payload.page;
      state.referralLimit = action.payload.pageSize;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOffers.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchOffers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
      state.total = action.payload?.totalOffers;
      state.totalRedeemed = action.payload?.totalRedeemed;
    });
    builder.addCase(fetchOffers.rejected, (state, action) => {
      state.isLoading = false;
      state.data = [];
      state.error = action.error.message;
    });



    builder.addCase(fetchReferral.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchReferral.fulfilled, (state, action) => {

      console.log(action?.payload,'abcc');
      state.isLoading = false;
      state.referralData = action.payload.data;
      state.error = null;
      state.referralTotal = action.payload?.totalCount;
      state.referralConversion = action.payload?.convertedCount;
    });
    builder.addCase(fetchReferral.rejected, (state, action) => {
      state.isLoading = false;
      state.referralData = [];
      state.error = action.error.message;
    });
  },
});

export const { setPaginationModel, resetPaginationModel,setReferralPaginationModel,resetReferralPaginationModel } = offerSlice.actions;
export default offerSlice.reducer;
